<template>
    <div class="p-relative">

       <div class="wrapperForm dashboardWrapper">
            <v-row dense>
                <v-col cols="12" sm="12" md="8" class="section-wrapper">
                    <v-card flat>
                        <v-card-text>
                            <div class="form-box-title title-with-right-part">
                                <span>{{ $t("Статусы_поручений") }}</span>
                                <div class="twrp-content twrp-content-filter-p">
                                    <v-select
                                        v-model="byStatusGraphView"
                                        :items="byViewList"
                                        item-text="view"
                                        item-value="id"
                                        hide-details
                                        outlined
                                        dense
                                        append-icon="fas fa-chevron-down"
                                        class="autocomplete-chip autocomplete-chip-22"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        :style="comboBoxStyle"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div class="group-chart-vidget">
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="dataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <template v-if="!dataSourceLoading && byStatusCommonSeries.series.length">
                                        <RingChartjs
                                            typeChart="donut"
                                            :series="byStatusCommonSeries" 
                                            :labels="ringChartLabelsPreparation(statusNames)"
                                            :colors="statusColors"
                                            :click="byStatusCommonClick"
                                            heightChart="330px"
                                            :showLabels="true"
                                            :showLegend="false"
                                            ref="byStatusRingChart"
                                            @chart-ready="onStatusRingReady"
                                        />
                                    </template>
                                </div>
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="dataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <div 
                                        v-if="!dataSourceLoading && byStatusData && byStatusData.length"
                                        class="overflow-y-auto overflow-x-hidden" 
                                        style="height:330px;"
                                    >
                                        <BarChartjsStack
                                            :key="'Status'+byStatusGraphView+locale"
                                            :datasource="byStatusData" 
                                            :categories="byStatusLabels"
                                            :click="byStatusClick"
                                            :showLegend="false"
                                            :barThickness="barThickness"
                                            ref="byStatusBarChart"
                                            @chart-ready="onStatusBarReady"
                                        />
                                    </div>
                                </div>
       
                            </div>
                            <div>
                                <shared-legend  
                                    v-if="statusChartInstances.length"                                        
                                    :charts="statusChartInstances" 
                                />
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="4" class="section-wrapper">
                    <v-card flat>
                        
                        <v-card-text>
                            <div class="form-box-title">{{ $t("Поручения_с_нарушением_срока_исполнения") }}</div>
                            <v-skeleton-loader
                                v-if="dataSourceLoading"
                                class="mx-auto"
                                max-height="330"
                                min-height="330"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>
                            <template v-if="!dataSourceLoading && tasksWithViolatedDeadlinesSeries.series.length">
                                <RingChartjs
                                    :key="'tasksWithViolatedDeadlines'+locale"
                                    typeChart="pie"
                                    :series="tasksWithViolatedDeadlinesSeries" 
                                    :labels="ringChartLabelsPreparation(tasksWithViolatedDeadlinesLabels)" 
                                    :colors="tasksWithViolatedDeadlinesColors"    
                                    :click="tasksWithViolatedDeadlinesClick"
                                    :showTotal="false"
                                    heightChart="330px"    
                                    :showLegend="false"
                                    @chart-ready="onTasksWithViolatedDeadlinesBarReady"                                                            
                                />
                                                            <div>
                                <shared-legend  
                                    v-if="tasksWithViolatedDeadlinesInstances.length"                                        
                                    :charts="tasksWithViolatedDeadlinesInstances" 
                                   
                                />
                            </div>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>

            <v-row dense>
                <v-col cols="12" sm="12" md="8" class="section-wrapper">
                    <v-card flat>
                        <v-card-text>
                            <div class="form-box-title title-with-right-part">
                                <span>{{ $t("Сроки_исполнения_поручений") }}</span>
                                <div class="twrp-content twrp-content-filter-p">
                                    <v-select
                                        v-model="bySrokGraphView"
                                        :items="byViewList"
                                        item-text="view"
                                        item-value="id"
                                        hide-details
                                        outlined
                                        dense
                                        append-icon="fas fa-chevron-down"
                                        class="autocomplete-chip autocomplete-chip-22"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        :style="comboBoxStyle"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div class="group-chart-vidget">
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="dataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <template v-if="!dataSourceLoading && bySrokCommonSeries.series.length">
                                        <RingChartjs
                                            :key="'BySrokCommon'+locale"
                                            typeChart="donut"
                                            :series="bySrokCommonSeries" 
                                            :labels="ringChartLabelsPreparation(srokNames)"
                                            :colors="srokColors"
                                            :click="bySrokCommonClick"
                                            heightChart="330px"
                                            :showLabels="true"
                                            :centerText="getBySrokText"
                                            :showLegend="false"
                                            @chart-ready="onSrokRingReady"
                                        />
                                    </template>
                                </div>
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="dataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <div 
                                        v-if="!dataSourceLoading && bySrokData && bySrokData.length"
                                        class="overflow-y-auto overflow-x-hidden" 
                                        style="height:330px;"
                                    >
                                        <BarChartjsStack
                                            :key="'Srok'+bySrokGraphView+locale"
                                            :datasource="bySrokData" 
                                            :categories="bySrokLabels"
                                            :click="bySrokClick"
                                            :showLegend="false"
                                            :barThickness="barThickness"
                                            @chart-ready="onSrokBarReady"
                                        />
                                    </div>
                                </div>

                            </div>
                            <div>
                                <shared-legend  
                                    v-if="srokChartInstances.length"                                        
                                    :charts="srokChartInstances" 
                                />
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="4" class="section-wrapper">
                    <v-card flat>
                        
                        <v-card-text>
                            <div class="form-box-title">{{ $t("Просроченные_поручения") }}</div>
                            <v-skeleton-loader
                                v-if="dataSourceLoading"
                                class="mx-auto"
                                max-height="330"
                                min-height="330"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>
                            <template v-if="!dataSourceLoading && BySrokExpiredSeries.series.length">
                                <RingChartjs
                                    :key="'BySrokExpired'+locale"
                                    :series="BySrokExpiredSeries" 
                                    :labels="ringChartLabelsPreparation(BySrokExpiredLabels)" 
                                    :colors="BySrokExpiredColors"    
                                    :click="BySrokExpiredClick"
                                    :showTotal="true"
                                    :centerText="getByExpiriedSrokText"
                                    heightChart="330px"    
                                    :showLegend="false"
                                    @chart-ready="onExpiriedSrokRingReady"
                                />
                                <div>
                                    <shared-legend  
                                        v-if="expiriedSrokChartInstances.length"                                        
                                        :charts="expiriedSrokChartInstances" 
                                    />
                                </div>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>

            <v-row dense>
                <v-col cols="12" sm="12" md="8" class="section-wrapper">
                    <v-card flat>
                        <v-card-text>
                            <div class="form-box-title title-with-right-part">
                                <span>{{ $t("Исполнительская_дисциплина") }}</span>
                                <div class="twrp-content twrp-content-filter-p">
                                    <v-btn
                                        small
                                        depressed
                                        color="teal"
                                        class="text-capitalize white--text"
                                        @click="performingDisciplineReportClick"
                                    >
                                        {{$t("Сформировать_отчет")}}
                                    </v-btn>
                                </div>
                            </div>
                            <div class="group-chart-vidget">
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="dataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <template v-if="!dataSourceLoading && performingDisciplineSeries.series.length">
                                        <RingChartjs
                                            :key="'performingDiscipline'+locale"
                                            :asGauge="true"
                                            :series="performingDisciplineSeries" 
                                            :labels="[$t('Исполнительская_дисциплина')]" 
                                            :colors="performingDisciplineRingChartColors"
                                            :click="performingDisciplineClick"
                                            heightChart="330px"
                                            :showLabels="false"
                                            :showLegend="false"
                                            :showToolTips="false"
                                            :centerText="getPerformingDisciplineText"
                                        />
                                    </template>
                                </div>
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="dataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <div 
                                        v-if="!dataSourceLoading && executionOfEmployeesData && executionOfEmployeesData.length"
                                        class="overflow-y-auto overflow-x-hidden" 
                                        style="height:330px;"
                                    >
                                        <BarChartjsStack
                                            :key="'executionOfEmployees'+locale"
                                            :datasource="executionOfEmployeesData" 
                                            :categories="executionOfEmployeesLabels"
                                            :colors="performingDisciplineColors"
                                            :click="performingDisciplineClick"
                                            :barThickness="barThickness"
                                            :showLegend="false"
                                            @chart-ready="onExecutionOfEmployeesBarReady"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <shared-legend  
                                    v-if="executionOfEmployeesChartInstances.length"                                        
                                    :charts="executionOfEmployeesChartInstances" 
                                    mode="dataset"
                                />
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="12" md="8" class="section-wrapper">
                    <v-card flat>
                        <v-card-text>
                            <div class="form-box-title">
                                <span>{{ $t("Сферы_деятельности") }}</span>
                            </div>
                            <div class="group-chart-vidget">
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="dataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <div 
                                        v-if="!dataSourceLoading && bySphereLeftData && bySphereLeftData.length"
                                        class="overflow-y-auto overflow-x-hidden" 
                                        style="height:330px;"
                                    >
                                        <BarChartjsStack
                                            :key="'SphereLeft'+locale"
                                            :datasource="bySphereLeftData" 
                                            :categories="bySphereLeftLabels"
                                            :click="bySphereLeftClick"
                                            :barThickness="barThickness"
                                            :showLegend="false"
                                            :wordWrap="true"
                                            :max-value="100"
                                            :yAxisTickLabelWidth="250"
                                            @chart-ready="onSphereLeftBarReady"
                                        />
                                    </div>
                                </div>
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="dataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <div 
                                        v-if="!dataSourceLoading && bySphereRightData && bySphereRightData.length"
                                        class="overflow-y-auto overflow-x-hidden" 
                                        style="height:330px;"
                                    >
                                        <BarChartjsStack
                                            :key="'SphereRight'+locale"
                                            :datasource="bySphereRightData" 
                                            :categories="bySphereRightLabels"
                                            :click="bySphereRightClick"
                                            :barThickness="barThickness"
                                            :showLegend="false"
                                            :wordWrap="true"
                                            :max-value="100"
                                            :yAxisTickLabelWidth="250"
                                            @chart-ready="onSphereRightBarReady"
                                        />
                                    </div>
                                </div>
                            </div>
                             <div>
                                <shared-legend  
                                    v-if="sphereChartInstances.length"                                        
                                    :charts="sphereChartInstances" 
                                    mode="dataset"
                                />
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

       </div>

    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
//import _ from 'lodash';
//import sys from '@/services/system';
import { mapGetters, mapMutations } from 'vuex';

//chartjs
import RingChartjs from '@/components/chartjs/ringChart';
import BarChartjsStack from '@/components/chartjs/barChartStack';
import SharedLegend from '@/components/chartjs/sharedLegend';

export default {
    name: "Reporting",
    components: {
        RingChartjs,
        BarChartjsStack,
        SharedLegend
    },
    
    data: () => {
        return {
            dataSourceLoading: true,
            dataSource: null,
            barThickness : 30,
            minPercentRing: 4,

            byStatusCommonSeries: [],
            byStatusControlersData: [],
            byStatusExecutersData: [],
            byStatusGraphView: 0,
            statusNames: [
                "Просрочено",
                "В_работе",
                "Исполнено"
            ],
            statusColors: [
                '#f04747',
                '#FAA61A',
                '#43B581',
                //'transparent'
            ],      

            
            bySrokCommonSeries: [],
            bySrokControlersData: [],
            bySrokExecutersData: [],
            bySrokGraphView: 0,
            srokNames: [
                //"Просрочено",
                "Срок_сегодня",
                "Срок_менее_10_дней",
                "Срок_более_10_дней"
            ],
            srokColors: [
                //'#f04747',
                '#f57731',
                '#FAA61A',
                '#43B581'
            ],      
            
            tasksWithViolatedDeadlinesSeries: null,
            tasksWithViolatedDeadlinesLabels: [
                'На_рассмотрении',
                'На_исполнении',
                'На_проверке_исполнения',
                'На_снятии_с_контроля'
            ],
            tasksWithViolatedDeadlinesColors: [
                '#43B581',
                '#f57731',
                '#9B84EE',
                '#FAA61A'
            ],

            //eqaDataSourceLoading: true,
            eqaDataSource: null,
            performingDisciplineLabels: [
                'Просрочено',
                'Исполнено_с_нарушением_срока',
                'Исполнено_в_срок',
            ],
            performingDisciplineColors: [
                '#F04747',
                '#f57731',
                '#43B581'
            ],
            performingDisciplineTotalLabel: '%',

            bySphereData: [],
            statusChartInstances: [],
            expiriedSrokChartInstances: [],
            srokChartInstances: [],
            performingDisciplineChartInstances: [],
            sphereChartInstances: [],

            executionOfEmployeesChartInstances: [],
            tasksWithViolatedDeadlinesInstances: [],

            BySrokExpiredSeries: null,
            BySrokExpiredLabels: [
                'менее_30_дней',
                'от_30_до_60_дней',
                'от_60_до_90_дней',
                '90_дней_и_более'
            ],
            BySrokExpiredColors: [
                '#faa61a',
                '#f57731',
                '#c4452d',
                '#7f5493'
            ],
        }
    },
    computed: {
        ...mapGetters('global/auth', ['getUserInfo']),
        ...mapGetters('documents/references', { spheresList: 'GetSpheres'}),
        minPercent() {
            return 6;
        },
        fontSize(){
            return 20;
        },
        locale(){
            return this.$i18n.locale;
        },
        comboBoxStyle(){
            if (this.locale == 'kk')
                return 'width:220px;'
            return 'width:180px;'
        },
        byViewList() { 
            return [
                { id: 0, view: this.$t('По_исполнителям') },
                { id: 1, view: this.$t('По_контролерам') },
            ]
        },
        byStatusUsedData(){
            return this.byStatusGraphView == 1 ? this.byStatusControlersData : this.byStatusExecutersData;
        },
        byStatusData(){
            if ( this.byStatusUsedData && this.byStatusUsedData.length > 0) {
                let sourceData = this.byStatusUsedData.reduce((a, e) => {
                    a.push([e.overdue, e.inwork, e.executed]) 
                    return a;
                }, []);
                return this.barChartDataPreparation(sourceData, this.statusNames, this.statusColors);
            }
            return [];
        },
        byStatusLabels() {
            if ( this.byStatusUsedData && this.byStatusUsedData.length > 0)
                return this.barChartLabelsPreparation(this.byStatusUsedData);
            return [];
        },
        bySrokUsedData() {
            return this.bySrokGraphView == 1 ? this.bySrokControlersData : this.bySrokExecutersData;
        },
        bySrokData(){
            if ( this.bySrokUsedData && this.bySrokUsedData.length > 0) {
                let sourceData = this.bySrokUsedData.reduce((a, e) => {
                    a.push([/*e.expired,*/ e.today, e.lessThan10Days, e.moreThan10Days]) 
                    return a;
                }, []);
                return this.barChartDataPreparation(sourceData, this.srokNames, this.srokColors);
            }
            return [];
        },
        bySrokLabels() {
            if ( this.bySrokUsedData && this.bySrokUsedData.length > 0) 
                return this.barChartLabelsPreparation(this.bySrokUsedData);
            return [];
        },
        getBySrokText(){
            const value = this.bySrokCommonSeries?.values.reduce((acc, value) => acc + value, 0);
            if (value)
                return [`${value}`, `${this.$t('Всего_в_работе')}`];
            return '';
        },
        performingDisciplineSeries() {
            if (this.eqaDataSource && this.eqaDataSource.length > 0) {
                
                const v = this.eqaDataSource.reduce((acc, obj) => {
                        for (const key in obj) {
                            if (typeof obj[key] === 'number') {      // <-- суммируем только числа
                            acc[key] = (acc[key] || 0) + obj[key];
                            }
                        }
                        return acc;
                    }, {});

                if (v.total != 0){
                    const r = v.total == 0 ? 0 : Math.round(((v.executed + v.executedoverdue * 0.5)/(v.total)) * 100);
                    return {
                        series: [r, 100 - r],
                        values: []
                    };
                }
            }

            return {
                series: [],
                values: []
            };
        },
        performingDisciplineRingChartColors(){
            if (this.performingDisciplineSeries) {
                let r = this.performingDisciplineSeries.series[0];
                let colorsData = [
                    { start: 0, end: 29, color: '#f04747' },
                    { start: 30, end: 49, color: '#f57731' },
                    { start: 50, end: 74, color: '#FAA61A' },
                    { start: 75, end: 100, color: '#43B581' },
                ];
                
                let resultColor = colorsData.find(e => r >= e.start && r <= e.end);
                return resultColor ? [resultColor.color, 'transparent'] : ['#43B581', 'transparent']; 
            }
            
            return ['#43B581', 'transparent'];
        },
        getPerformingDisciplineText(){
            const value = this.performingDisciplineSeries?.series[0];
            if (value)
                return [`${value}%`, ...this.$t("Исполнительская_дисциплина").split(' ')];
            return '';
        },
        executionOfEmployeesSortedSourceData() {
            if (this.eqaDataSource && this.eqaDataSource.length > 0) {
                return Object.values(
                    this.eqaDataSource.reduce((acc, obj) => {
                        const executerid = obj.executerid;
                        // Если объекта с таким id ещё нет — создаём копию, но все числовые поля обнулим
                        let executerCounts = acc.find(a => a.executerid == executerid); 
                        if (!executerCounts) {
                            executerCounts = { executerid, executername: obj.executername};
                            acc.push(executerCounts);
                        }

                        for (const key in obj) {
                            const value = obj[key];

                            if (typeof value === "number" && key !== "id") {
                                executerCounts[key] = (executerCounts[key] || 0) + value;
                            }
                        }

                        return acc;
                    }, []).sort((a, b) => {
                        const sumA = a.executedoverdue + a.executed;
                        const sumB = b.executedoverdue + b.executed;
                        return sumA - sumB;
                    })
                );
            }
            return [];
        },
        executionOfEmployeesData() {
            if (this.executionOfEmployeesSortedSourceData && this.executionOfEmployeesSortedSourceData.length > 0) {
                
                let sourceData = this.executionOfEmployeesSortedSourceData.reduce((a, e) => {

                    a.push([e.overdue, e.executedoverdue, e.executed]) 

                    return a;
                }, []);

                return this.barChartDataPreparation(sourceData, this.performingDisciplineLabels, this.performingDisciplineColors);
            }

            return [];
        },
        executionOfEmployeesLabels() {
            if (this.executionOfEmployeesSortedSourceData && this.executionOfEmployeesSortedSourceData.length > 0) {
                return this.executionOfEmployeesSortedSourceData.reduce((a, e) => {
                    a.push(e.executername);
                    return a;
                }, []).reverse();
            }
            return [];
        },
        getMaxSphereValue(){
            return Math.max(...this.bySphereData.map(e => e.overdue + e.inwork + e.executed));
        },
        bySphereLeftData(){
            if (this.bySphereData && this.bySphereData.length > 0) {
                let sourceData = this.bySphereData.filter((_, i) => i % 2 === 0).reduce((a, e) => {
                    a.push([e.overdue, e.inwork, e.executed])
                    return a;
                }, []);

                return this.barChartDataPreparation(sourceData, this.statusNames, this.statusColors, this.getMaxSphereValue);
            }
            return [];
        },
        bySphereLeftLabels(){
            if (this.bySphereData && this.bySphereData.length > 0)
                return this.barChartLabelsPreparation(this.bySphereData.filter((_, i) => i % 2 === 0).map(e => ({name: this.spheresList?.find(s => s.id == e.id)?.Value})));
            return [];
        },
        bySphereRightData(){
            if (this.bySphereData && this.bySphereData.length > 0) {
                let sourceData = this.bySphereData.filter((_, i) => i % 2 !== 0).reduce((a, e) => {
                    a.push([e.overdue, e.inwork, e.executed])
                    return a;
                }, []);
                return this.barChartDataPreparation(sourceData, this.statusNames, this.statusColors, this.getMaxSphereValue);
            }
            return [];
        },
        bySphereRightLabels(){
            if (this.bySphereData && this.bySphereData.length > 0)
                return this.barChartLabelsPreparation(this.bySphereData.filter((_, i) => i % 2 !== 0).map(e => ({name: this.spheresList?.find(s => s.id == e.id)?.Value})));
            return [];
        },
        getByExpiriedSrokText(){
            const value = this.BySrokExpiredSeries?.values.reduce((acc, value) => acc + value, 0);
            if (value)
                return [`${value}`, `${this.$t('Просрочено')}`];
            return '';
        },
    },
    methods: {
        ...mapMutations('orders/lists/svetofor', 
            { 
                setSvetoforStatus: 'SET_STATUS', 
                resetSvetoforExtendedFilter: 'RESET_EXTENDED_FILTER',
                setSvetoforExtendedFilterExecuters: 'SET_EXTENDED_FILTER_EXECUTERS',
                setSvetoforExtendedFilterControllers: 'SET_EXTENDED_FILTER_CONTROLLERS',
                setSvetoforExtendedFilterSphere: 'SET_EXTENDED_FILTER_SPHERE'
            }),
        ...mapMutations('orders/lists/protocolscompleted', 
            { 
                setProtocolCompletedStatus: 'SET_STATUS', 
                resetProtocolCompletedExtendedFilter: 'RESET_EXTENDED_FILTER',
                setProtocolCompletedExtendedFilterExecuters: 'SET_EXTENDED_FILTER_EXECUTERS',
                setProtocolCompletedExtendedFilterControllers: 'SET_EXTENDED_FILTER_CONTROLLERS',
                setProtocolCompletedExtendedFilterSphere: 'SET_EXTENDED_FILTER_SPHERE'
            }),
        ...mapMutations('orders/lists/protocolsbypastperiods', 
            {
                setExecutionStatus: 'SET_EXECUTION_STATUS',
            }),
       async getData() {
            
            this.dataSourceLoading = true;      
            //this.performingDisciplineDataLoad();

            const response = await httpAPI.get('api/orders/reportingsection');
            if (response){
                this.dataSource = response.data.Payload;
                const data0 = this.dataSource?.ByStatusTotal;
                if (!data0){
                    this.byStatusCommonSeries =  { series: [], values: [] };
                }
                else {
                    this.byStatusCommonSeries = this.getRingChartSeries([data0.Overdue, data0.InWork, data0.Executed]);
                }
                const data1 = this.dataSource?.ByStatusByController;
                if ( data1 && data1.length > 0){
                    this.byStatusControlersData = data1.map(item => ({id: item.Id, name: item.Name, inwork: item.InWork, executed: item.Executed, overdue: item.Overdue}))
                        .sort((a, b) => {
                            let delta = a.overdue - b.overdue;
                            if (delta == 0)
                                delta = a.inwork - b.inwork;
                            return delta; 
                        })
                }
                else {
                    this.byStatusControlersData = []
                }
                const data2 = this.dataSource?.ByStatusByExecuter;
                if (data2 && data2.length > 0){
                    this.byStatusExecutersData = data2.map(item => ({id: item.Id, name: item.Name, inwork: item.InWork, executed: item.Executed, overdue: item.Overdue}))
                        .sort((a, b) => {
                            let delta = a.overdue - b.overdue;
                            if (delta == 0)
                                delta = a.inwork - b.inwork;
                            if (delta == 0)
                                delta = a.executed - b.executed;
                            return delta; 
                        })
                }
                else {
                    this.byStatusExecutersData = []
                }

                const data3 = this.dataSource?.BySrokTotal;
                if (!data3){
                    this.bySrokCommonSeries =  { series: [], values: [] };
                }
                else {
                    this.bySrokCommonSeries = this.getRingChartSeries([/*data3.Expired,*/ data3.Today, data3.LessThan10Days, data3.MoreThan10Days]);
                }

                const data4 = this.dataSource?.BySrokByController;
                this.bySrokControlersData = data4?.filter(item => item.Today + item.LessThan10Days + item.MoreThan10Days > 0).map(item => ({id: item.Id, name: item.Name, expired: item.Expired, today: item.Today, lessThan10Days: item.LessThan10Days, moreThan10Days: item.MoreThan10Days}))
                    .sort((a, b) => {
                        let delta = a.today - b.today;
                        if (delta == 0)
                            delta = a.lessThan10Days - b.lessThan10Days;
                        if (delta == 0)
                            delta = a.moreThan10Days - b.moreThan10Days;
                        return delta; 
                    }) ?? [];

                const data5 = this.dataSource?.BySrokByExecuter;
                if (data5 && data5.length > 0){
                    this.bySrokExecutersData = data5.filter(item => item.Today + item.LessThan10Days + item.MoreThan10Days > 0).map(item => ({id: item.Id, name: item.Name, expired: item.Expired, today: item.Today, lessThan10Days: item.LessThan10Days, moreThan10Days: item.MoreThan10Days}))
                        .sort((a, b) => {
                            let delta = a.today - b.today;
                            if (delta == 0)
                                delta = a.lessThan10Days - b.lessThan10Days;
                            if (delta == 0)
                                delta = a.moreThan10Days - b.moreThan10Days;
                            return delta; 
                        })
                }
                else {
                    this.bySrokExecutersData = []
                }

                const data6 = this.dataSource?.ByStatusBySphere;
                this.bySphereData = [];
                if ( data6 && data6.length > 0){
                    this.bySphereData = data6.map(item => ({id: item.Sphere, name: null, inwork: item.InWork, executed: item.Executed, overdue: item.Overdue}))
                        .sort((a, b) => {
                            let delta = a.overdue - b.overdue;
                            if (delta == 0)
                                delta = a.inwork - b.inwork;
                            return delta; 
                        });
                }

                const tasksWithViolatedDeadlinesData = this.dataSource?.OrderOverdueStat;
                this.tasksWithViolatedDeadlinesSeries = { series: [], values: [] };
                if (tasksWithViolatedDeadlinesData) {

                    this.tasksWithViolatedDeadlinesSeries = this.getRingChartSeries([
                        tasksWithViolatedDeadlinesData.oninspect, 
                        tasksWithViolatedDeadlinesData.overdue, 
                        tasksWithViolatedDeadlinesData.oncheckexecution, 
                        tasksWithViolatedDeadlinesData.ontakeoffcontrol
                    ]);
                }

                this.eqaDataSource = this.dataSource?.ExecutionQuality;

                const expiriedSroks = this.dataSource?.BySrokExpired;
                this.BySrokExpiredSeries = { series: [], values: [] };
                if (expiriedSroks) {
                    this.BySrokExpiredSeries = this.getRingChartSeries([
                        expiriedSroks.expiredlessthan30days, 
                        expiriedSroks.expiredmore30less60, 
                        expiriedSroks.expiredmore60less90, 
                        expiriedSroks.expiredmorethan90days
                    ])
                }
            }

            this.dataSourceLoading = false;
        },
        barChartDataPreparation(sourceData, names, colors, maxValue){
            if (!sourceData.length)
                return []; 

            let rotateClockwise = function (matrix) {
                return matrix[0].map((val, index) => matrix.map(row => row[index]).reverse());
            };

            const coef = 100 / (maxValue ? maxValue : Math.max.apply(null, sourceData.map((data) => data.map(v => v).reduce((a, v) => a + v, 0))));
            
            sourceData = rotateClockwise(sourceData);

            let percentageData = sourceData.map((data) => data.map(v => {
                let percentageValue = Math.round(coef * (v));
                return percentageValue > 0 && percentageValue < this.minPercent ? this.minPercent : percentageValue;
            }));

            let correctedData = sourceData.map((data) => data.map(v => {
                return (v == 0 ? "" : v);
            }));

            let result = percentageData.map((data, index ) => {

                let item = {
                    name: '',
                    data: data,
                    color: '#',
                    datalabels: {
                        formatter: function (value, context){ return correctedData[context.datasetIndex][context.dataIndex]; },
                        font: { size: this.fontSize }
                    },
                    value: sourceData[index]
                };
                item.name = this.$t(names[index]);
                item.color = colors[index];

                return item;
            });

            return result;
        },
        barChartLabelsPreparation(sourceData) {
            return sourceData.map(e => e.name ?? this.$t('Не_указано')).reverse();
        },
        barChartGetByReversIndex(sourceData, index){
            //console.log(sourceData, index);
            return sourceData[sourceData.length - 1 - index];
        },
        getRingChartSeries(sourceData){
            const coef = 100 / (sourceData.reduce((a, b) => a + b, 0));
            return {
                series: sourceData.map((value) => {
                    let percentageValue = Math.round(coef * (value));
                    return percentageValue > 0 && percentageValue < this.minPercent ? this.minPercent : percentageValue;
                }),
                values: sourceData                        
            };
        },
        ringChartLabelsPreparation(names){
            return names.map(item => this.$t(item));
        },  
        /*async performingDisciplineDataLoad(){
            this.eqaDataSourceLoading = true;
            const params = {
                type: 'execution-quality', 
                fromDate: `/Date(${ Date.parse(this.$moment().add(-2, 'month').startOf('month').format('YYYY-MM-DD'))})/`, 
                currentDate: `/Date(${ Date.parse(this.$moment().format('YYYY-MM-DD'))})/`,  
                toDate: `/Date(${ Date.parse(this.$moment().endOf('month').format('YYYY-MM-DD'))})/`
            };
            const response = await httpAPI({
                url: `api/orders/report?type=${params.type}`,
                method: 'POST',
                headers: { 'isCommon': true },
                data: { Content: JSON.stringify(params) }
            });
            if (response){
                this.eqaDataSource =  response ? response.data.Payload : null;
            }
            this.eqaDataSourceLoading = false;
        },*/
        byStatusCommonClick(event, chartContext, config) {
            //console.log(event, chartContext, config);

            switch (config.dataPointIndex)
            {
                case 0: { 
                    this.setSvetoforStatus('Expired'); 
                    this.resetSvetoforExtendedFilter();
                    this.$router.push({ path: "svetofor" });  
                    return;
                }
                case 1: { 
                    this.setSvetoforStatus('All'); 
                    this.resetSvetoforExtendedFilter();
                    this.$router.push({ path: "svetofor" });  
                    return;
                }
                case 2: { 
                    this.setProtocolCompletedStatus('All'); 
                    this.resetProtocolCompletedExtendedFilter();
                    this.$router.push({ path: "protocolscompleted" });  
                    return;
                }
            }
        },
        byStatusClick(event, chartContext, config) {
            //console.log(event, chartContext, config);
            //console.log('byStatusClick', this.barChartGetByReversIndex(this.byStatusGraphView == 0 ? this.byStatusControlersData: this.byStatusExecutersData, config.dataPointSelection));    
            
            const data = this.barChartGetByReversIndex(this.byStatusGraphView == 0 ? this.byStatusControlersData: this.byStatusExecutersData, config.dataPointSelection);

            switch(config.seriesIndex)
            {
                case 0: { 
                    this.setSvetoforStatus('Expired'); 
                    this.resetSvetoforExtendedFilter();

                    if (data.id)
                        this.byStatusGraphView == 0
                            ? this.setSvetoforExtendedFilterControllers([{id: data.id, value: data.name}])
                            : this.setSvetoforExtendedFilterExecuters([{id: data.id, value: data.name}]);

                    this.$router.push({ path: "svetofor" });  
                    return;
                }
                case 1: { 
                    this.setSvetoforStatus('All'); 
                    this.resetSvetoforExtendedFilter();
                    
                    if (data.id)
                        this.byStatusGraphView == 0
                            ? this.setSvetoforExtendedFilterControllers([{id: data.id, value: data.name}])
                            : this.setSvetoforExtendedFilterExecuters([{id: data.id, value: data.name}]);

                    this.$router.push({ path: "svetofor" });  
                    return;
                }
                case 2: { 
                    this.setProtocolCompletedStatus('All'); 
                    this.resetProtocolCompletedExtendedFilter();
                    
                    if (data.id)
                        this.byStatusGraphView == 0
                            ? this.setProtocolCompletedExtendedFilterControllers([{id: data.id, value: data.name}])
                            : this.setProtocolCompletedExtendedFilterExecuters([{id: data.id, value: data.name}]);

                    this.$router.push({ path: "protocolscompleted" });  
                    return;
                }
            }
        },
        bySrokCommonClick(event, chartContext, config) {
            //console.log(event, chartContext, config);

            switch (config.dataPointIndex)
            {
                case 0: this.setSvetoforStatus('Today'); break;
                case 1: this.setSvetoforStatus('LessThan10Days'); break;
                case 2: this.setSvetoforStatus('MoreThan10Days'); break;
            }

            this.resetSvetoforExtendedFilter();
            this.$router.push({ path: "svetofor" });  
        },
        bySrokClick(event, chartContext, config) {
            //console.log(event, chartContext, config);
            //console.log(this.barChartGetByReversIndex(this.bySrokExecutersData, config.dataPointSelection));

            const data = this.barChartGetByReversIndex(this.bySrokExecutersData, config.dataPointSelection);

            switch(config.seriesIndex)
            {
                case 0: this.setSvetoforStatus('Today'); break;
                case 1: this.setSvetoforStatus('LessThan10Days'); break;
                case 2: this.setSvetoforStatus('MoreThan10Days'); break; 
            }

            this.resetSvetoforExtendedFilter();
            
            if (data.id)        
                this.setSvetoforExtendedFilterExecuters([{id: data.id, value: data.name}]);

            this.$router.push({ path: "svetofor" });  
        },
        bySphereLeftClick(event, chartContext, config) {
            //console.log(event, chartContext, config);
            const L = Math.ceil(this.bySphereData.length / 2);
            const originalIndex = 2 * (L - 1 - config.dataPointSelection);
            //console.log(this.bySphereData[originalIndex]);

            const data = this.bySphereData[originalIndex];

            switch(config.seriesIndex)
            {
                case 0: { 
                    this.setSvetoforStatus('Expired'); 
                    this.resetSvetoforExtendedFilter();

                    if (data.id)
                        this.setSvetoforExtendedFilterSphere({id: data.id, value: data.name});
                    else
                        this.setSvetoforExtendedFilterSphere({id: 0, value: this.$i18n.t('Не_указано') });

                    this.$router.push({ path: "svetofor" });  
                    return;
                }
                case 1: { 
                    this.setSvetoforStatus('All'); 
                    this.resetSvetoforExtendedFilter();
                    
                    if (data.id)
                        this.setSvetoforExtendedFilterSphere({id: data.id, value: data.name});
                    else
                        this.setSvetoforExtendedFilterSphere({id: 0, value: this.$i18n.t('Не_указано') });

                    this.$router.push({ path: "svetofor" });  
                    return;
                }
                case 2: { 
                    this.setProtocolCompletedStatus('All'); 
                    this.resetProtocolCompletedExtendedFilter();
                    
                    if (data.id)
                        this.setProtocolCompletedExtendedFilterSphere({id: data.id, value: data.name});
                     else
                        this.setProtocolCompletedExtendedFilterSphere({id: 0, value: this.$i18n.t('Не_указано') });

                    this.$router.push({ path: "protocolscompleted" });  
                    return;
                }
            }
        },
        bySphereRightClick(event, chartContext, config){
            //console.log(event, chartContext, config);
            const R = Math.floor(this.bySphereData.length / 2);
            const originalIndex = 2 * (R - 1 - config.dataPointSelection) + 1;
            //console.log(this.bySphereData[originalIndex]);

            const data = this.bySphereData[originalIndex];

            switch(config.seriesIndex)
            {
                case 0: { 
                    this.setSvetoforStatus('Expired'); 
                    this.resetSvetoforExtendedFilter();

                    if (data.id)
                        this.setSvetoforExtendedFilterSphere({id: data.id, value: data.name});
                    else
                        this.setSvetoforExtendedFilterSphere({id: 0, value: this.$i18n.t('Не_указано') });

                    this.$router.push({ path: "svetofor" });  
                    return;
                }
                case 1: { 
                    this.setSvetoforStatus('All'); 
                    this.resetSvetoforExtendedFilter();
                    
                    if (data.id)
                        this.setSvetoforExtendedFilterSphere({id: data.id, value: data.name});
                    else
                        this.setSvetoforExtendedFilterSphere({id: 0, value: this.$i18n.t('Не_указано') });

                    this.$router.push({ path: "svetofor" });  
                    return;
                }
                case 2: { 
                    this.setProtocolCompletedStatus('All'); 
                    this.resetProtocolCompletedExtendedFilter();
                    
                    if (data.id)
                        this.setProtocolCompletedExtendedFilterSphere({id: data.id, value: data.name});
                    else
                        this.setProtocolCompletedExtendedFilterSphere({id: 0, value: this.$i18n.t('Не_указано') });

                    this.$router.push({ path: "protocolscompleted" });  
                    return;
                }
            }
        },
        BySrokExpiredClick(event, chartContext, config) {
            console.log(event, chartContext, config);

            switch(config.dataPointIndex)
            {
                case 0: this.setExecutionStatus('ExpiredLessThan30Days'); break;
                case 1: this.setExecutionStatus('ExpiredMore30Less60'); break;
                case 2: this.setExecutionStatus('ExpiredMore60Less90'); break;
                case 3: this.setExecutionStatus('ExpiredMoreThan90Days'); break;
            }    

            this.$router.push({ path: "protocolsbypastperiods" });  
            
        },
        tasksWithViolatedDeadlinesClick(event, chartContext, config) {
            console.log(event, chartContext, config);
        },
        performingDisciplineClick(event, chartContext, config) {
            console.log(event, chartContext, config);
        },
        performingDisciplineReportClick(){
            let exportURI = `api/orders/reportfile?type=execution-quality&filter=${JSON.stringify({
                type: 'execution-quality', 
                fromDate: `/Date(${ Date.parse(this.$moment().add(-2, 'month').startOf('month').format('YYYY-MM-DD'))})/`, 
                currentDate: `/Date(${ Date.parse(this.$moment().format('YYYY-MM-DD'))})/`,  
                toDate: `/Date(${ Date.parse(this.$moment().endOf('month').format('YYYY-MM-DD'))})/`
                , format: 'Xls'})}`;

            let text = this.$i18n.t('Исполнительская_дисциплина');

            this.$eventBus.$emit('on-get-report', {url: exportURI, text: text, type: 'xls' });
        },
        onStatusRingReady(chart) {
            this.$set(this.statusChartInstances, 0, chart)
        },
        onExpiriedSrokRingReady(chart) {
            this.$set(this.expiriedSrokChartInstances, 0, chart)
        },
        onStatusBarReady(chart) {
            this.$set(this.statusChartInstances, 1, chart)
        },
        onSrokRingReady(chart) {
            this.$set(this.srokChartInstances, 0, chart)
        },
        onSrokBarReady(chart) {
            this.$set(this.srokChartInstances, 1, chart)
        },
        onSphereLeftBarReady(chart) {
            this.$set(this.sphereChartInstances, 0, chart)
        },
        onSphereRightBarReady(chart) {
            this.$set(this.sphereChartInstances, 1, chart)
        },
        onExecutionOfEmployeesBarReady(chart) {
            this.$set(this.executionOfEmployeesChartInstances, 0, chart)
        },
        onTasksWithViolatedDeadlinesBarReady(chart) {
            this.$set(this.tasksWithViolatedDeadlinesInstances, 0, chart)
        },
    },
    created() {
        
    },
    mounted() {
        this.getData();
    },
    beforeDestroy() {

    }   
}
</script>
